import Compressores from './Compressores';

export default Compressores;
